module.exports = __webpack_public_path__ + "media/images/riders/small/JULIEN_ABSALON-a3dcd6a29915f50c5fd1dc7eb8eacbc5.png";